import { isEmpty } from 'validations';

export const validateAcademyEvent = (event) => {
	var isValid = true;
	let messages = [];

	if (isEmpty(event.name)) {
		isValid = false;
		messages.push('Event name is required');
	}

	if (isEmpty(event.description)) {
		isValid = false;
		messages.push('Event description is required');
	}

	if (isEmpty(event.start_date)) {
		isValid = false;
		messages.push('Start date is required');
	}

	if (isEmpty(event.end_date)) {
		isValid = false;
		messages.push('End date is required');
	}

	if (isEmpty(event.timezone)) {
		isValid = false;
		messages.push('Timezone is required');
	}

	let validation = {
		isValid,
		messages
	};

	return validation;
};
